module.exports = __webpack_public_path__ + "img/cpjs8.5d542ad2.png";